import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalEntityGeoprocessingReadAction from './legalEntityGeoprocessingRead.action.json' assert { type: 'json' }

const legalEntityGeoprocessingReadDefinition = defineReadAutoAction(
  legalEntityGeoprocessingReadAction,
  'legalEntityGeoprocessing',
)

export default legalEntityGeoprocessingReadDefinition
